import { Form, Input, InputNumber } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";

const SessionTime: React.FC = () => {
  const { t } = useTranslation();
  return (
    // <Form.Item
    //   name="session_time"
    //   label="Session Time (In Minutes)"
    //   rules={[
    //     {
    //       required: true,
    //       message: "Please enter Session Time",
    //     },
    //   ]}
    // >
    //   <InputNumber
    //     style={{ width: "100%" }}
    //     controls={false}
    //     changeOnWheel={false}
    //   />
    // </Form.Item>
    <Form.Item
      name="sessionMinutes"
      label="Session Time (In Minutes)"
      rules={[
        {
          required: true,
          message: t("error:sync_time_is_required"),
        },
      ]}
    >
      <InputNumber
        style={{ width: "100%" }}
        controls={false}
        changeOnWheel={false}
      />
    </Form.Item>
  );
};

export default SessionTime;
